import { Suspense, useEffect } from 'react';

import { Outlet } from 'react-router-dom';
import { toast } from 'react-toastify/unstyled';

import { AppNavigation } from '@app/navigation/AppNavigation';
import { usePendo } from '@app/pendo/usePendo';
import { useAppSelector } from '@app/store/store';
import { useGetUserByEmailQuery } from '@features/user-management/api/user-management.api';
import { LoadingPageSpinner } from '@shared/overlays';

export function App() {
  const { username } = useAppSelector((state) => state.authentication);

  const { isError, data: user } = useGetUserByEmailQuery(username ?? '', {
    skip: !username,
  });

  usePendo(user);

  useEffect(() => {
    if (isError) {
      toast.error('Error retrieving user details', { toastId: 'user-details-error' });
    }
  }, [isError]);

  return (
    <div className="flex flex-col flex-1 min-h-screen bg-background" data-testid="main-container-layout">
      <AppNavigation />

      <main className="flex flex-col flex-1 min-h-0" data-testid="main-container-content">
        <Suspense fallback={<LoadingPageSpinner />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}
